export type PageEntry = number | "ellipsis";

function range(start: number, end: number): number[] {
  if (end < start) return [];
  const out: number[] = [];
  for (let index = start; index <= end; index++) out.push(index);
  return out;
}

export function buildPageList(
  current: number,
  total: number,
  sibling = 1,
): PageEntry[] {
  const entries: PageEntry[] = [];
  const boundary = 1;
  const startPages = range(1, Math.min(boundary, total));
  const endPages = range(Math.max(total - boundary + 1, boundary + 1), total);

  const siblingStart = Math.max(current - sibling, boundary + 2);
  const siblingEnd = Math.min(current + sibling, total - boundary - 1);

  entries.push(...startPages);
  if (siblingStart > boundary + 2) {
    entries.push("ellipsis");
  } else if (boundary + 1 < total - boundary) {
    entries.push(boundary + 1);
  }

  entries.push(...range(siblingStart, siblingEnd));

  if (siblingEnd < total - boundary - 1) {
    entries.push("ellipsis");
  } else if (total - boundary > boundary) {
    entries.push(total - boundary);
  }

  entries.push(...endPages);

  const seen = new Set<number>();
  return entries.filter((entry) => {
    if (entry === "ellipsis") return true;
    if (seen.has(entry)) return false;
    seen.add(entry);
    return true;
  });
}

export { formatRecordTotal as formatTotal } from "@shared/records/record-total";
